module.exports = __webpack_public_path__ + "media/images/mindmap-58d4433f10b960d75c0c53988d1a4c89.svg";